import React from "react";
import Form from "antd/es/form";
import Input from "antd/es/input";
import Checkbox from "antd/es/checkbox";
import Button from "antd/es/button";
import Select from "antd/es/select";
import { Card, Row, Col, Typography } from "antd";
import Flex from "antd/es/flex";
import http, { httpIntegration } from "../utils/http";
import ModalClosed from "./ModalClosed";

export default function FormAuth({
  setLoading,
  setResponse,
  onWait,
  platform,
  lat,
  long,
}) {
  const [form] = Form.useForm();
  // const [applicants, setApplicants] = React.useState([]);
  const [isModal, setIsModal] = React.useState(false);

  // const fetchApplicants = async () => {
  //   const loginResponse = await httpIntegration().post("/auth/loginCustom", {
  //     email: "agent@infomedia.co.id",
  //     password: "12345678",
  //     tokenCaptcha: "string",
  //     pbx: "",
  //   });
  //   if (loginResponse.status === 200 && !loginResponse?.data?.error) {
  //     const response = await httpIntegration(loginResponse?.data?.token).get(
  //       "/custom/applicant-type/list"
  //     );
  //     if (response.status === 200 && !response?.data?.error) {
  //       setApplicants(
  //         response.data?.map((item) => ({ label: item?.name, value: item?.id }))
  //       );
  //     }
  //   }
  // };

  const onSubmit = (values) => {
    let time = new Date().getHours() * 60 + new Date().getMinutes();
    let start = 8 * 60;
    let end = 16 * 60;

    if (time >= start && time <= end) {
      setIsModal(false);

      values.phone = `+62${values.phone}`;
      values.platform = platform ? platform : "twilio";
      if (parseInt(process.env.REACT_APP_USE_LOCATION) === 1) {
        values.location = {
          latitude: lat,
          longitude: long,
        };
      }
      setLoading(true);
      http
        .post(
          `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_TENANT}/requestQueue`,
          values
        )
        .then(async (res) => {
          if (res) {
            setLoading(false);
            setResponse(res.data);
            if (platform === "vonage") {
              onWait(res.data);
            } else {
              if (res.data.body?.email) {
                onWait(
                  res.data.token,
                  res.data.room.uniqueName,
                  res.data.body?.email
                );
              } else {
                onWait(
                  res.data.token,
                  res.data.room.uniqueName,
                  res.data.body?.phone
                );
              }
            }
          }
        })
        .catch((err) => {
          setLoading(false);
        });
    } else {
      setIsModal(true);
    }
  };

  // React.useEffect(() => {
  //   fetchApplicants();
  // }, []);

  return (
    <div
      style={{
        backgroundColor: "#ebeff2",
        margin: 0,
        padding: "24px 0px",
        height: "100%",
      }}
    >
      {!isModal ? (
        <div className="App-Container">
          <img src={`siviki logo.png`} alt="Logo" width={180} />
          <Row gutter={[64, 64]} style={{ margin: "0px 24px" }}>
            <Col md={24} lg={12}>
              <Form
                form={form}
                name="basic"
                layout="vertical"
                onFinish={onSubmit}
                onFinishFailed={(e) => console.log(e)}
              >
                <Typography.Title
                  level={4}
                  style={{ color: window.THEMES.chatBubbleIn }}
                >
                  Registrasi
                </Typography.Title>
                <Form.Item
                  // label="Nama lengkap"
                  name="name"
                  rules={[{ required: true, message: "Name wajib diisi" }]}
                  hasFeedback
                >
                  <Input placeholder="Nama lengkap" />
                </Form.Item>

                <Form.Item
                  // label="Email"
                  name="email"
                  rules={[
                    {
                      required: true,
                      message: "Email wajib diisi",
                    },
                    { type: "email", message: "Email tidak valid" },
                  ]}
                  hasFeedback
                >
                  <Input placeholder="Email" />
                </Form.Item>

                <Form.Item
                  // label="No Telepon"
                  name="phone"
                  rules={[{ required: true, message: "Nomor wajib diisi" }]}
                  hasFeedback
                >
                  <Input prefix="+62" placeholder="Ex: 81903430650" />
                </Form.Item>

                <Form.Item
                  // label="Jenis Kekayaan Intelektual"
                  name="jenisKekayaanIntelektual"
                  rules={[
                    {
                      required: true,
                      message: "Jenis Kekayaan Intelektual Wajib dipilih",
                    },
                  ]}
                  hasFeedback
                >
                  <Select
                    placeholder="Pilih Jenis Kekayaan Intelektual"
                    options={[
                      { value: "Indikasi Geografis" },
                      { value: "Design Tata letak Sirkuit Terpadu" },
                      { value: "Aduan Layanan" },
                      { value: "Merek" },
                      { value: "Design Industri" },
                      { value: "Hak Cipta" },
                      { value: "HKI Umum" },
                      { value: "Paten" },
                      { value: "Rahasia Dagang" },
                    ]}
                  />
                </Form.Item>

                <Form.Item
                  // label="Asal Provinsi"
                  name="jenisPemohon"
                  rules={[
                    {
                      required: true,
                      message: "Jenis Pemohon Wajib dipilih",
                    },
                  ]}
                  hasFeedback
                >
                  <Select
                    placeholder="Pilih Jenis Pemohon"
                    options={[
                      { value: "Badan Hukum" },
                      { value: "Kementerian/Lembaga" },
                      { value: "Konsultan KI" },
                      { value: "Litbang" },
                      { value: "Perguruan Tinggi" },
                      { value: "Perorangan" },
                      { value: "Sentra KI Kementerian" },
                      { value: "Sentra KI Litbang" },
                      { value: "Sentra KI Perguruan Tinggi" },
                      { value: "UMKM" },
                    ]}
                    // options={applicants}
                    // filterOption={(input, option) =>
                    //   (option?.label ?? "")
                    //     .toLowerCase()
                    //     .includes(input.toLowerCase())
                    // }
                  />
                </Form.Item>

                <Form.Item
                  name="agreement"
                  valuePropName="checked"
                  hasFeedback
                  rules={[
                    {
                      required: true,
                      message: "Harap ceklis persetujuan.",
                    },
                  ]}
                >
                  <Checkbox style={{ fontSize: 12 }}>
                    Saya setuju dengan syarat dan ketentuan dan kebijakan
                    privasi
                  </Checkbox>
                </Form.Item>
                <Button type="primary" htmlType="submit" block shape="round">
                  Submit
                </Button>
              </Form>
            </Col>
            <Col md={24} lg={12}>
              <Flex vertical>
                <Typography.Title
                  level={4}
                  style={{ color: window.THEMES.chatBubbleIn }}
                >
                  Ketentuan Video Conference
                </Typography.Title>
                <Card
                  style={{ background: "#f2f3f6", border: "2px solid gray" }}
                >
                  <Flex gap={24} align="center" justify="center">
                    <Flex vertical align="center">
                      <img
                        src="https://crm-sipengadu.dgip.go.id/assets/images/icon/logo-max-time.png"
                        width={82}
                        height={82}
                        alt="Logo"
                      />
                      <Typography.Text
                        strong
                        style={{ fontSize: 14, textAlign: "center" }}
                      >
                        Maksimal Waktu 15 Menit
                      </Typography.Text>
                    </Flex>
                    <Flex vertical align="center">
                      <img
                        src="https://crm-sipengadu.dgip.go.id/assets/images/icon/turn-on-microphone.png"
                        width={82}
                        height={82}
                        alt="Logo"
                      />
                      <Typography.Text
                        strong
                        style={{ fontSize: 14, textAlign: "center" }}
                      >
                        Wajib Mengaktifkan Microphone
                      </Typography.Text>
                    </Flex>
                    <Flex vertical align="center">
                      <img
                        src="https://crm-sipengadu.dgip.go.id/assets/images/icon/turn-on-camera.png"
                        width={82}
                        height={82}
                        alt="Logo"
                      />
                      <Typography.Text
                        strong
                        style={{ fontSize: 14, textAlign: "center" }}
                      >
                        Wajib Mengaktifkan Kamera
                      </Typography.Text>
                    </Flex>
                  </Flex>
                </Card>
                <Typography.Title
                  level={4}
                  style={{ color: window.THEMES.chatBubbleIn }}
                >
                  Profil DJKI
                </Typography.Title>
                <Card
                  style={{
                    background: "black",
                    border: "2px solid gray",
                  }}
                >
                  <iframe
                    width="100%"
                    height="100%"
                    src="https://www.youtube.com/embed/zO6lY1M_NIY?autoplay=1&mute=1"
                    title="Tutorial Video Conference"
                    frameBorder="0"
                    allowFullScreen
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    style={{ minHeight: "240px", flexGrow: 1 }}
                  ></iframe>
                </Card>
              </Flex>
            </Col>
          </Row>
        </div>
      ) : (
        <ModalClosed
          onClose={() => {
            setIsModal(false);
            form.resetFields();
          }}
        />
      )}
    </div>
  );
}
